module.exports = __webpack_public_path__ + "img/atlas-1.90edca2c.png";